import { useState, useContext, useEffect } from "react";
import { Context } from "../Context/GlobalState";
import CircularProgress from "@material-ui/core/CircularProgress";
import LoadingXencodes from "./LoadingXencodes";
import { FaGoogle } from "react-icons/fa";

export default function Login({ history }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLogin, setIsLogin] = useState("false");

  const { signup } = useContext(Context);
  const [signupEmail, setSignupEmail] = useState("");
  const [signupUsername, setSignupUsername] = useState("");
  const [signupFullName, setSignupFullName] = useState("");
  const [signupPassword, setSignupPassword] = useState("");
  const [signupIsLoading, setSignupIsLoading] = useState(false);

  // To get the data from the Context
  const {
    login,
    loginWithGoogle,
    isPageLoading,
    setIsPageLoading,
    authError,
    OAuthError,
  } = useContext(Context);

  useEffect(() => {
    setIsPageLoading(true);
  }, [setIsPageLoading]);
 
  const handlelogin = (e) => {
    e.preventDefault();

    setIsLoading(true);
    
    login(
      email,
      password,
      () => history.push("/home"),
      () => setIsLoading(false)
    );
  };

  const handleGoogleLogin = () => {
    loginWithGoogle(() => history.push("/set-profile"));
  };

  const handleLoginWindow = () => {
    setIsLogin(!isLogin);
  };

  // To show a loading page when page loads on re-authentication
  if (isPageLoading) {
    return <LoadingXencodes />;
  }

  const handleSignup = (e) => {
    e.preventDefault();

    setIsLoading(true);
    signup(
      signupEmail,
      signupUsername,
      signupFullName,
      signupPassword,
      () => history.push("/home"),
      () => setIsLoading(false)
    );
  };

  return (
    <div className="login__container">
      <div className={isLogin ? "container" : "container right__panel__active"} id="container">
        <div className="form__container sign__up__container">
          <form onSubmit={handleSignup}>
            <h1>Create Account</h1>
            <div className="social__container">
              <a href="#" className="social"><FaGoogle /></a>
            </div>
            <span>or use your email for registration</span>
            <input
                type="email"
                id="Email"
                name="Email"
                placeholder="Email"
                value={signupEmail}
                onChange={(e) => setSignupEmail(e.target.value)}
                required
              />
              <input
                type="text"
                id="Username"
                name="Username"
                placeholder="Username"
                value={signupUsername}
                onChange={(e) => setSignupUsername(e.target.value)}
                required
              />     
              <input
                type="text"
                id="FullName"
                name="FullName"
                placeholder="FullName"
                value={signupFullName}
                onChange={(e) => setSignupFullName(e.target.value)}
                required
              />             
              <input
                type="password"
                id="password"
                name="Password"
                placeholder="Password"
                value={signupPassword}
                onChange={(e) => setSignupPassword(e.target.value)}
                required
              />
              <button disabled={signupIsLoading}>
                {!signupIsLoading ? (
                  "Sign up"
                ) : (
                  <CircularProgress size={20} color="inherit" />
                )}
              </button>
              <div className="auth__error">
                <small>{authError}</small>
              </div>
          </form>
        </div>
        <div className="form__container sign__in__container">
          <form onSubmit={handlelogin}>
            <h1>XenCodes</h1>
            <div className="social__container"  onClick={handleGoogleLogin}>
              <a className="social"> <FaGoogle /></a>
              <span>Log in with Google</span> 
            </div>
            <span>or use your account</span>
            <input
                type="email"
                id="Email"
                name="Email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
            />
            <input
              type="password"
              id="password"
              name="Password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            {/* <a href="#">Forgot your password?</a> */}
            <button disabled={isLoading}>
              {!isLoading ? (
                "Sign In"
              ) : (
                <CircularProgress size={20} color="inherit" />
              )}
            </button>
            {authError && (
              <div className="auth__error">
                <small>{authError}</small>
              </div>
            )}
            {OAuthError && (
              <div className="auth__error">
                <small>{OAuthError}</small>
              </div>
            )}            
          </form>
        </div>
        <div className="overlay__container">
          <div className="overlay">
            <div className="overlay__panel overlay__left">
              <h1>Welcome Back!</h1>
              <p>To keep connected with us please login with your personal info</p>
              <button className="ghost" id="signIn" onClick={handleLoginWindow}>Sign In</button>
            </div>
            <div className="overlay__panel overlay__right">
              <h1>Hello, Scholars!</h1>
              <p>Enter your personal details and start journey with us</p>
              <button className="ghost" id="signUp" onClick={handleLoginWindow}>Sign Up</button>
            </div>
          </div>
        </div>
      </div>

      <footer>
        <p>
          XenCodes Team
        </p>
      </footer>
    </div>
  );
}
